import { mockFormField } from '@domgen/dgx-fe-forms/layout';
import { CmsDirectDebitForm } from '../../models/cms/cms-direct-debit-form.interface';
import { mockCmsPaperlessPreferenceFieldset } from './cms-paperless-preference-fieldset.mock';

export const mockCmsDirectDebitForm: CmsDirectDebitForm = {
  accountHolderConfirmationField: mockFormField,
  accountNameField: mockFormField,
  accountNumberField: mockFormField,
  ibanField: mockFormField,
  paperlessPreferenceFieldset: mockCmsPaperlessPreferenceFieldset,
  paymentDateField: mockFormField,
  sortCodeField: mockFormField,
};
